<!--<div class="document-container">-->
<div style="min-height: 100vh; height: auto; overflow: visible; position: relative">
  @for (page of pages; track $index; let i = $index; let last = $last) {
    <div class="page">
      <div class="black-stripe"></div>
      <!-- Encabezado Fijo -->
      <div class="header flex flex-center-between">
        <div>
          <h1 class="text-header-16 text-semibold">{{ isInvoiceOrder ? 'Estado de pago: ' : 'Orden de compra: ' }}<span
            style="color: #0072F5">#{{ order.reference }}</span></h1>
        </div>
        <div>
          <img class="svg-container" [src]="environment.baseUrl + '/assets/images/image_20.png'" (load)="onLogoLoaded()"
               width="64" height="28" alt="logo">
        </div>
      </div>

      <div class="content" #pageContent>
        <!-- Primera página tiene contenido fijo -->
        @if (page.showStaticTop) {
          <div class="static-section" #staticContentArea>
            <!-- Nueva sección de información -->
            @if (client && order) {
              <div class="info-section">
                <div class="info-item">
                  <div class="info-label">Proyecto:</div>
                  <div class="info-value">
                    <span class="info-value-bold">{{ pdfProject?.name || '-' }}</span>
                    <span class="info-value-regular">{{ pdfProject?.reference || '-' }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">{{this.isInvoiceOrder ? 'Cliente' : 'Proveedor'}}:</div>
                  <div class="info-value">
                    <span class="info-value-bold">{{ client.name || '-' }}</span>
                    <span class="info-value-regular">{{ client.vat || '-' }}</span>
                  </div>
                </div>
                @if (showExchangeRate) {
                  <div class="info-item">
                    <div class="info-label">Tipo de cambio:</div>
                    <div class="info-value">
                      <span class="info-value-bold">{{ currentCurrency?.currentCurrencyExchange?.baseRate }}</span>
                      <span class="info-value-regular">({{ getExchangeDateFormatted() }})</span>
                    </div>
                  </div>
                }
              </div>
            }

            <!-- Valor del servicio-->
            <div class="invoice-container" style="box-sizing: border-box;">
            <!-- Tabla de valores -->
            <nz-descriptions nzBordered
                             [nzColumn]="2"
                             class="invoice-table custom-invoice-style">
              <!-- Fila 1 -->
              <!-- Valor del servicio: SIN impuesto (total de la columna de importes del Resumen distribución) -->
              <nz-descriptions-item nzTitle="Valor del servicio" [nzSpan]="2" class="semibold">
                <span
                  class="text-semibold">{{ totalRow.amount | number:'1.2-2' }} {{ currentCurrency?.isoCode || '' }}</span>
              </nz-descriptions-item>

              <!-- Fila 2 -->
              <nz-descriptions-item nzTitle="Gastos reembolsables" [nzSpan]="2">
                {{ order.reimbursableExpenses | number:'1.2-2' }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 3 - I.V.A. -->
              <nz-descriptions-item [nzTitle]="ivaText" [nzSpan]="2">
                {{ totalRow.totalTaxOrderCurrency | number:'1.2-2' }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 4 - Total -->
              <nz-descriptions-item nzTitle="Total" [nzSpan]="2">
                {{ (totalRow.amount + totalRow.totalTaxOrderCurrency) | number:'1.2-2' }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 5 -->
              <nz-descriptions-item nzTitle="Retención" [nzSpan]="2">
                {{ order.retention | number:'1.2-2' }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 6 (Total a pagar) -->
              <nz-descriptions-item [nzSpan]="2"
                                    nzTitle="Total a pagar"
                                    class="semibold"
              >
                <span
                  class="text-semibold">{{ (totalRow.amount + totalRow.totalTaxOrderCurrency + (order.reimbursableExpenses ?? 0) + (order.retention ?? 0)) | number:'1.2-2' }} {{ currentCurrency?.isoCode || '' }}</span>
              </nz-descriptions-item>
            </nz-descriptions>
            </div>
          </div>
        }

        <!-- Contenido dinámico que fluye entre páginas -->
        @if (page.summary; as summarySection) {
          <!-- Resumen de distribucion del servicio-->
          <div class="factura-tabla" #summarySectionContainer>
              <span class="text-label-10 text-semibold color-grey-10 subTitle">Resumen distribución</span>
              <nz-table #summaryTable [nzShowPagination]="false" nzBordered [nzData]="summarySection.rows" [nzPageSize]="100">
                <thead>
                <tr>
                  <th>Identificación de costos</th>
                  <th nzAlign="right">Valor unitario</th>
                  <th nzAlign="right">Detalle</th>
                  @for (currencyColumn of dinamicCurrencyColumns; track currencyColumn) {
                    <th nzAlign="center">{{ currencyColumn.name }}
                    </th>
                  }
                  <th nzAlign="right">{{ ivaText }}</th>
                  <th nzAlign="right">Monto</th>
                </tr>
                </thead>
                <tbody>
                  @for (group of summaryTable.data; track group.displayIndex; let rowIndex = $index) {
                    <tr>
                      <td>
                        <div class="service-name-container">
                          <div class="service-name-row">
                            <span class="service-index">{{ group.displayIndex ?? (rowIndex + 1) }}.</span>
                            <span class="service-name">{{ group.displayLabel || '-' }}</span>
                          </div>
                          <!-- Detalles distintos de las Operaciones Analíticas agrupadas en esta fila -->
                          @for (detail of group.details; track detail) {
                            <div class="service-operations">{{ detail }}</div>
                          }
                        </div>
                      </td>
                      <td nzAlign="right">{{
                        group.unitPrice != null && group.unitPrice !== undefined
                          ? (group.unitPrice | number:'1.2-2')
                          : '-'
                      }}</td>
                      <td nzAlign="right">{{ group.totalQuantity != null ? (group.totalQuantity | number:'1.0-0') : '-' }}</td>
                      @for (currencyColumn of dinamicCurrencyColumns; track currencyColumn) {
                        <td nzAlign="center">
                          {{
                            (group.totalDinamicData ?? {})['currency_' + currencyColumn.id]
                              ? ((group.totalDinamicData ?? {})['currency_' + currencyColumn.id] | number: '1.2-2')
                              : '-'
                          }}
                        </td>
                      }
                      <td nzAlign="right">{{
                        group.totalTaxOrderCurrency != null && group.totalTaxOrderCurrency !== undefined
                          ? (group.totalTaxOrderCurrency | number:'1.2-2')
                          : '-'
                      }} ({{ (getVatPercent(group.totalTaxOrderCurrency, group.totalAmountOrderCurrency) | number:'1.0-0') ?? '-' }}%)</td>
                      <td nzAlign="right">
                        <b>{{
                            group.totalAmountOrderCurrency != null && group.totalTaxOrderCurrency != null
                              ? ((group.totalAmountOrderCurrency + group.totalTaxOrderCurrency) | number:'1.2-2')
                              : '-'
                          }}</b>
                      </td>
                    </tr>
                  }
                </tbody>
              </nz-table>

              <!-- Espacio de 4px -->
              <!--              <ng-container *ngIf="block.isLastChunk">-->
              <div style="height: 4px;margin:0;"></div>

              @if (summarySection.includeTotals) {
                <table class="totals-table" style="display: inline-table" #summaryInlineTable>
                  <tbody>
                  <!-- Fila de totales (estática) -->
                  <tr class="total-row">
                    <td style=" height: 22px; padding-left: 10px" class="text-semibold"><span>Totales</span></td>
                    <td class="text-semibold"><span>{{ totalRow.averageUnitPrice | number:'1.2-2' }}</span></td>
                    <td class="text-semibold"><span>{{ totalRow.detail | number:'1.0-0' }}</span></td>
                    @for (currencyColumn of dinamicCurrencyColumns; track currencyColumn) {
                      <td nzAlign="center">
                          {{
                            totalRow.totalDinamicData['currency_' + currencyColumn.id]
                              ? (totalRow.totalDinamicData['currency_' + currencyColumn.id] | number: '1.2-2')
                              : '-'
                          }}
                      </td>
                    }
                    <td class="text-semibold"><span>{{ totalRow.totalTaxOrderCurrency | number:'1.2-2' }}</span> ({{ (getVatPercent(totalRow.totalTaxOrderCurrency, totalRow.amount) | number:'1.0-0') ?? '-' }}%)</td>
                    <td class="text-semibold"><span>{{ (totalRow.amount + totalRow.totalTaxOrderCurrency) | number:'1.2-2' }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              }
          </div>

        }
        @if (page.operations; as operationsSection) {
          <!--      Detalles de operaciones-->
          <div class="factura-tabla servicio-tabla flex flex-column" #operationsSectionContainer style="gap:4px; ">
            <div style="height: 20px;"><span class="text-label-10 text-semibold color-grey-10 subTitle">Detalle operaciones</span>
            </div>
            @if (operationsSection.includeTotalsSummary) {
              <div #operationsSummaryRow style="height: 22px; display: flex; justify-content: space-between; padding: 0 12px;">
                <div>
                  <span class="subtitle2Bold">{{ getTotalServiceOrders() }}&nbsp;</span>
                  <span class="subtitle2">Operaciones</span>
                </div>
                <div>
                  <span class="subtitle2">Total:&nbsp;</span>
                  <span class="subtitle2Bold">{{ getTotalAmount() | number:'1.2-2' }}&nbsp;{{ currentCurrency?.isoCode || '' }}</span>
                </div>
              </div>
            }
            <nz-table #unifiedOperationsTable [nzData]="operationsSection.rows" [nzShowPagination]="false" nzBordered
                      [nzPageSize]="10000">
                <thead>
                <tr>
                  <th nzAlign="center">Operación</th>
                  <th nzAlign="center">Servicio</th>
                  <th nzAlign="center">Motonave</th>
                  <th nzAlign="center">Contenedor</th>
                  <th nzAlign="center">Ref. CEC</th>
                  <th nzAlign="center">Ref. Comercial</th>
                  <th nzAlign="center">Cantidad</th>
                  <th nzAlign="center">Valor unitario</th>
                  @if (showExchangeRate) {
                    <th nzAlign="center">Tipo de cambio</th>
                  }
                  <th nzAlign="center">Monto {{ currentCurrency?.isoCode || '' }}</th>
                </tr>
                </thead>
                <tbody>
                @for (data of unifiedOperationsTable.data; track data) {
                  <tr>
                    <td nzAlign="center">{{ data.operation.description || '-' }}</td>
                    <td nzAlign="center">{{ data.service.name || '-' }}</td>
                    <td nzAlign="center">{{ data.serviceOrder.motonave?.name || '-' }}</td>
                    <td nzAlign="center">{{ data.serviceOrder.projectContainer?.containerRef || '-' }}</td>
                    <td nzAlign="center">{{ data.serviceOrder.referenceCEC || '-' }}</td>
                    <td nzAlign="center">{{ data.serviceOrder.referenceCommercial || '-' }}</td>
                    <td nzAlign="center">{{ data.operation.quantity != null && data.operation.quantity !== undefined ? data.operation.quantity : '-' }}</td>
                    <td nzAlign="center">{{ data.operation.unitPrice != null && data.operation.unitPrice !== undefined ?
                      (data.operation.unitPrice | number:'1.2-2')
                      : '-' }}</td>
                    @if (showExchangeRate) {
                      <td nzAlign="center">{{ currentCurrency?.currentCurrencyExchange?.baseRate }}</td>
                    }
                    <td nzAlign="center"><span>{{
                        data.amountInOrderCurrency != null && data.amountInOrderCurrency !== undefined
                          ? (data.amountInOrderCurrency | number: '1.2-2')
                          : '-'
                      }}</span></td>
                  </tr>
                }
                </tbody>
              </nz-table>
          </div>

        }
        @if (page.showSignature) {
          <div class="signature-section" #signatureSection>
            <div style="height: 20px;"><span class="text-label-10 text-semibold color-grey-10 subTitle">Ruta de firmas</span></div>
            <div style="padding: 12px; background-color: #FAFAFA; border-radius: 6px; height: 75px;">
              <!--
                SOU-481: el orden de las columnas ya no está escrito a mano. Se deriva de la
                fecha de cada paso, así que un EP anterior al cambio se reimprime con su
                recorrido original (Enviado antes de Aprobado) y uno nuevo con el actual.
              -->
              <nz-row class="signature-header">
                @for (step of signatureSteps; track step.key) {
                  <nz-col nzSpan="6">{{ step.title }} por</nz-col>
                }
              </nz-row>

              <!-- Fila de datos -->
              <nz-row class="signature-data">
                @for (step of signatureSteps; track step.key) {
                  <nz-col nzSpan="6" class="signature-col">
                    <div class="signature-name">
                      <span>{{ step.partner?.name || '-' }} {{ step.partner?.surName }}</span></div>
                    <div class="signature-area">{{ step.partner?.position || '-' }}</div>
                    <div class="signature-entity">{{ step.partner?.parentPartner?.name }}</div>
                  </nz-col>
                }
              </nz-row>
            </div>
          </div>
        }
      </div>

      <div class="footer" #pageFooter>
        <div class="footer-note">Nota: El plazo máximo para enviar observaciones {{ isInvoiceOrder ? 'del EP' : 'de la OC' }} es de 48 hrs, por lo que, pasado este plazo se procederá con la facturación sin derecho a nota de crédito o modificación en la factura.</div>
        <div class="page-number">Página {{ i + 1 }}/{{ pages.length }}</div>
      </div>
    </div>
    @if (!last) {
      <div class="page-break"></div>
    }
  }

  @if (isPdfReady) {
    <div class="pdf-ready"
         style="display: none">
    </div>
  }

</div>
